import React from 'react'
import { useNavigate } from 'react-router-dom';
import ButtonComponent from '../../components/ButtonComponent';

const PaymentPolicy = () => {
    const navigate = useNavigate();
    const handleBackToPolicyPage = () => {
        navigate('/documents');
    }
    return (
        <>
            <div className="container mt-5 privacy-policy"><ButtonComponent title='Back to Policy Page' backgroundColor=' #590B21' onClick={handleBackToPolicyPage} /></div>
            <div className="container mt-2 mb-5 py-4">
                <h3 className='fw-bold'>Payment Policy</h3>
                <h6 className='fw-bold'>CURRY KING (PRIVATE) LIMITED</h6>
                <p> Version 1.2 | Last Updated: 6th May 2025</p>
                <p>
                    This Payment Policy outlines the terms and conditions governing payment transactions for products and services offered by Curry King (Private) Limited via our mobile application (iOS and Android), website, and authorised food cart distribution network.
                </p>
                <hr />
                <h5 className='fw-bold'>1. Accepted Payment Methods</h5>
                <p>
                    We offer the following payment options for your convenience:
                </p>
                <ul>
                    <li>
                        <strong>Credit and Debit Cards</strong> (Visa, MasterCard, Amex, and others)
                    </li>
                    <li>
                        <strong>Cash on Pickup</strong> at designated Curry King food carts
                    </li>
                    <li>
                        <strong>Mobile Payment Links</strong> (sent via WhatsApp or SMS for prepaid orders)
                    </li>
                    <li>
                        <strong>Promotional Discount Cards</strong> (e.g., HNB Credit Cards with active offers)
                    </li>
                </ul>
                <p>All electronic transactions are processed through <strong>secure, PCI-DSS compliant payment gateways</strong> to ensure the safety and confidentiality of your financial information.</p>
                <hr />
                <h5 className='fw-bold'>2. Payment Timing</h5>
                <ul>
                    <li>
                        <strong>Prepaid Orders:</strong> Customers choosing to pay via credit or debit card must complete payment <strong>at the time of ordering</strong>, using the provided payment link or online checkout process.
                    </li>
                    <li>
                        <strong>Cash Payments:</strong> Must be made <strong>in full at the time of pickup</strong> at the designated food cart.
                    </li>
                    <li>
                        <strong>Corporate Accounts (if applicable): </strong>May be subject to invoicing terms based on prior written agreement.
                    </li>
                </ul>
                <hr />
                <h5 className='fw-bold'>3. Order Confirmation</h5>
                <ul>
                    <li>
                        An <strong>Order Confirmation</strong> will be issued upon successful payment, via email, SMS, or WhatsApp, including a unique <strong>Order Code.</strong>
                    </li>
                    <li>
                        This code must be presented at the time of pickup from the food cart for order verification and handover.
                    </li>
                </ul>
                <hr />
                <h5 className='fw-bold'>4. Pricing & Charges</h5>
                <ul>
                    <li>
                        All product prices are listed in <strong>Sri Lankan Rupees (LKR)</strong> and are <strong>applicable taxes</strong> unless otherwise stated.
                    </li>
                    <li>
                        Prices are subject to change without prior notice; however, any order already placed and confirmed will be honoured at the confirmed price.
                    </li>
                    <li>
                        Delivery or service charges (if any) will be explicitly listed at the time of checkout.
                    </li>
                </ul>
                <hr />
                <h5 className='fw-bold'>5. Promotions & Discounts</h5>
                <ul>
                    <li>
                        Promotional offers (e.g., <strong>10% off with HNB Credit Cards</strong>) are subject to specific terms and may not be combined with other discounts unless expressly stated.
                    </li>
                    <li>
                        Curry King reserves the right to verify eligibility before applying any promotional rate and to <strong>revoke discounts</strong> in the event of misuse or fraud.
                    </li>
                </ul>
                <hr />
                <h5 className='fw-bold'>6. Failed or Declined Transactions</h5>
                <p>If your payment fails or is declined:</p>
                <ul>
                    <li>
                        You will receive a notification and will be given an option to retry or choose an alternate payment method.
                    </li>
                    <li>
                        The order will remain in <strong>“Pending” status</strong> and will not be processed until payment is completed successfully.
                    </li>
                </ul>
                <hr />
                <h5 className='fw-bold'>7. Refunds (if applicable)</h5>
                <p>Refunds, where applicable under our Refund & Cancellation Policy, will be:</p>
                <ul>
                    <li>
                        Processed within <strong>5–7 business days</strong>
                    </li>
                    <li>
                        Issued to the <strong>original method of payment</strong>
                    </li>
                    <li>
                        Subject to deductions where applicable (e.g., promotional adjustments)
                    </li>
                </ul>
                <p>Please refer to our <strong>Refund & Cancellation Policy</strong> for full details</p>
                <hr />
                <h5 className='fw-bold'>8. Governing Law</h5>
                <p>
                    All transactions are governed by the laws of <strong>Sri Lanka</strong> , and any disputes arising from payment issues shall be resolved under the jurisdiction of competent Sri Lankan courts.
                </p>
                <p>
                    For further assistance, please contact us:
                </p>
                📞 <strong>+94 11 444 1300</strong>
                <br />
                📧 <strong>support@curryking.lk</strong>
                <hr />
            </div>
        </>
    )
}

export default PaymentPolicy;